import { baseUrl } from "config/apiUrl";
import { getUser } from "config/user";
import SuperFetch from "../config/SuperFetch";
let user = getUser();

const Product = {
  // productList: (page = 1, limit = 12) => {
  // 	return SuperFetch(
  // 		`${baseUrl.product}/v4/catalogs/buyer/discover?page=${page}&limit=${limit}&sort=price.desc`
  // 	);
  // },

  // productList: (page = 1, limit = 12) => {
  // 	if (user?.country === "Bangladesh") {
  // 		return SuperFetch(
  // 			`${baseUrl.product}/v4/products/buyer/ekk-trading-available-products?page=${page}&limit=${limit}`
  // 		);
  // 	} else {
  // 		return SuperFetch(
  // 			`${baseUrl.product}/v4/catalogs/buyer/discover?page=${page}&limit=${limit}&sort=price.desc`
  // 		);
  // 	}
  // },
  productList: (page = 1, limit = 12) => {
    return SuperFetch(
      `${baseUrl.bizNpdt}/products/?page=${page}&limit=${limit}`
    );
  },
  singleProductDetails: (id) => {
    return SuperFetch(`${baseUrl.bizNpdt}/seller/products/details/${id}/`);
  },
  singleProductDetailsOld: (id) => {
    return SuperFetch(`${baseUrl.bizNpdt}/offers/${id}`);
  },
  buyerSellerProductList: (buyer, seller, page = 1, limit = 10) => {
    return SuperFetch(
      `${baseUrl.bizNpdt}/sellers/${seller}/products?page=${page}&limit=${limit}`
    );
  },
  productSearch: (tarm, page = 1, limit = 500) => {
    return SuperFetch(
      `${baseUrl.bizNpdt}/products/search?term=${tarm}&page=${page}&limit=${limit}`
    );
  },
  // productSearch: (tarm, page = 1, limit = 500) => {
  // 	return SuperFetch(
  // 		`${baseUrl.bizNpdt}/v4/products/search/?search=${tarm}`
  // 	);
  // },

  offerProduct: (page = 1, limit = 10) => {
    return SuperFetch(`${baseUrl.bizNpdt}/offers/?page=${page}&limit=${limit}`);
  },
  offerProductDetails: (id) => {
    return SuperFetch(`${baseUrl.product}/v4/offers/${id}`);
  },
  productBrands: (id) => {
    return SuperFetch(`${baseUrl.bizNpdt}/sellers/${id}/brands`);
  },
  singleBrandProducts: (brandId, sellerId, page = 1, limit = 10) => {
    return SuperFetch(
      `${baseUrl.bizNpdt}/sellers/${sellerId}/brands/${brandId}/products/?page=${page}&limit=${limit}`
    );
  },

  // singleProductSearch: (sellerId, query, brandId) => {
  // 	return SuperFetch(
  // 		`${baseUrl.bizNpdt}/businesses/${sellerId}/products/?q=${query}&brand_id=${brandId}`
  // 	);
  // },
  singleProductSearch: (brandId, sellerId, query, page = 1) => {
    return SuperFetch(
      `${baseUrl.bizNpdt}/brands/${brandId}/sellers/${sellerId}/products/search/?term=${query}&page=${page}`
    );
  },
  sellerProductSearch: (sellerId, query, page = 1) => {
    return SuperFetch(
      `${baseUrl.bizNpdt}/sellers/${sellerId}/products/search/?term=${query}&page=${page}`
    );
  },
  brandProductSearch: (brandId, query, page = 1) => {
    return SuperFetch(
      `${baseUrl.bizNpdt}/brands/${brandId}/products/search/?term=${query}&page=${page}`
    );
  },
  offerSearch: (query, page = 1) => {
    return SuperFetch(
      `${baseUrl.bizNpdt}/seller/offer/search/?q=${query}&page=${page}`
    );
  },
  // audioProduct: (data) => {
  // 	return SuperFetch(`${baseUrl.audio}/voice/chatbot/`, {
  // 		method: "POST",
  // 		data: data,
  // 	});
  // },
  audioProduct: (data) => {
    return SuperFetch(`${baseUrl.audio}/voice/baz-chat/`, {
      method: "POST",
      data: data,
    });
  },
  getProducts: (query, page = 1, limit = 20) => {
    return SuperFetch(
      `${baseUrl.bizNpdt}/products/search/?term=${query}&page=${page}&limit=${limit}`
    );
  },
  getEmployeeData: (businessId, userId) => {
    return SuperFetch(
      `${baseUrl.bizNpdt}/ekkbaz/business-employee/${businessId}/?user_id=${userId}`
    );
  },
  getEmployeeHours: (userId, start, end, timeZone, page = 1, limit = 100) => {
    return SuperFetch(
      `${baseUrl.contract}/ekkbaz-employee-working-hour/?user_id=${userId}&start_date=${start}&end_date=${end}&timezone=${timeZone}&page=${page}&limit=${limit}`
    );
  },
  getEmployeeSalary: (employeeId, businessId) => {
    return SuperFetch(
      `${baseUrl.contract}/Ekkbaz/employee-salary/${employeeId}/?business_id=${businessId}`
    );
  },
  updateEmployeeSalary: (employeeId, query) => {
    return SuperFetch(
      `${baseUrl.contract}/Ekkbaz/employee-salary/${employeeId}/`,
      {
        method: "PUT",
        data: query,
      }
    );
  },
  getEmployeeSalaryList: (empId, page = 1, limit = 5) => {
    return SuperFetch(
      `${baseUrl.contract}/Ekkbaz/salary-payout/?emp_id=${empId}&page=${page}&limit=${limit}`
    );
  },
  getEmployeeHoursData: (userId, start, end, page = 1, limit = 30) => {
    return SuperFetch(
      `${baseUrl.contract}/ekkbaz-employee-working-hour/?user_id=${userId}&start_date=${start}&end_date=${end}&page=${page}&limit=${limit}`
    );
  },
  getEmployeeLeaveList: (empId, page = 1, limit = 5) => {
    return SuperFetch(
      `${baseUrl.contract}/Ekkbaz/admin-leave-application/${empId}/?page=${page}&limit=${limit}`
    );
  },
  singleSellerProductSearch: (
    query,
    type = "variant",
    selectedBrand,
    page = 1,
    limit = 10
  ) => {
    return SuperFetch(
      `${
        baseUrl.bizNpdt
      }/seller/products/search/?q=${query}&type=${type}&page=${page}&limit=${limit}${
        selectedBrand ? `&brand_id=${selectedBrand}` : ""
      }`
    );
  },
  sellerProductList: (
    type = "variant",
    selectedBrand,
    page = 1,
    limit = 12
  ) => {
    return SuperFetch(
      `${
        baseUrl.bizNpdt
      }/seller/products/?page=${page}&limit=${limit}&type=${type}${
        selectedBrand ? `&brand_id=${selectedBrand}` : ""
      }`
    );
  },
  singleOfferSearch: (query, page = 1, limit = 10) => {
    return SuperFetch(
      `${baseUrl.bizNpdt}/seller/offer/search/?q=${query}&page=${page}&limit=${limit}`
    );
  },
  getOfferList: (page = 1, limit = 12) => {
    return SuperFetch(
      `${baseUrl.bizNpdt}/seller/offer/?page=${page}&limit=${limit}`
    );
  },
  updateOffer: (data) => {
    return SuperFetch(`${baseUrl.bizNpdt}/seller/offer/update/`, {
      method: "PUT",
      data: data,
    });
  },
  updateProduct: (data) => {
    return SuperFetch(`${baseUrl.bizNpdt}/seller/products/update/`, {
      method: "PUT",
      data: data,
    });
  },
  checkMultiBusiness: () => {
    return SuperFetch(`${baseUrl.bizNpdt}/ekkbaz/associate-business-admin/`);
  },
  getMultiBusinessData: () => {
    return SuperFetch(
      `${baseUrl.contract}/Ekkbaz/multi-business-employee-card/`
    );
  },
};

export default Product;
